import React, { useState, useEffect } from 'react';
import {useGetCryptosQuery} from '../../../services/cryptoAPI';
import millify from 'millify';
import {Link} from 'react-router-dom';
import {Row, Col, Input, Typography} from 'antd';
import Spinner from '../../utils/Spinner';
import style from './CryptoCurrencies.module.css'

const Cryptocurrencies = ({simplified}) => {
    const count = simplified ? 10 : 100;
    const {data: cryptosList, isFetching} = useGetCryptosQuery(count);
    const [coinsData, setCoinsData] = useState([]);

    const handleChange = (e) => {
        const term = e.target.value;
        const filter = cryptosList.data.coins.filter((coin) => (coin.name.toLowerCase().includes(term.toLowerCase())))
        setCoinsData(filter)
    } 

    useEffect(() => {
        setCoinsData(cryptosList?.data?.coins);
    }, [cryptosList])

    return (
        <>
            <div className={style.currencyContainer}>
            <Typography.Title level={3} style={{textAlign: 'center', padding: "1rem 0"}}
            >
                Trending Cryptocurrencies
            </Typography.Title>
            {
                !simplified ? (
                        <div className='search-crypto'>
                            <Input placeholder='Search Cryptocurrency' onChange={handleChange}/>
                        </div>
                    )
                : <></>
            }
            <br/>

            {
                isFetching ? 
                    ( <Spinner /> ) :
                    ( <Row gutter={[32,32]} style={{alignItems: 'stretch', padding: "0 2rem"}}>
                        {
                            coinsData?.map((currency, i) => (
                                <Col xs={24} sm={12} lg={8} key={currency.id}>
                                    <Link to={`/crypto/currencies/${currency.id}`} style={{textDecoration: "none"}}>
                                       <div className={`${style.cryptoCard} card shadow`}>
                                        <div className={style.cryptoCardHeading}>
                                            <span>{i + 1}. &nbsp; <strong>{currency.name}</strong></span>
                                            <span><img src={currency.iconUrl} alt="extra"/></span>
                                        </div>
                                       <div dangerouslySetInnerHTML={{__html: currency.description?.slice(0, 100)}}>
                                        </div>
                                        <div className={style.cryptoCardPrice}>
                                            <p>      
                                                <strong>Price</strong> 
                                                <br/><br/> 
                                                <em><strong>{millify(currency.price)}</strong></em>
                                            </p>
                                            <p>            
                                                <strong>Market Cap</strong> 
                                                <br/><br/> 
                                                <em><strong>{millify(currency.marketCap)}</strong></em>
                                            </p>
                                            <p>            
                                                <strong>Daily Change</strong>  
                                                <br/><br/> 
                                                <em><strong style={{color: `${currency.change > 0 ? "green": "red"}`}}>{currency.change} %</strong></em>
                                            </p>
                                            </div>
                                       </div>
                                    </Link>
                                </Col>
                            ))
                        }
                        </Row>
                    )
            }
            </div>
        </>
    )
}

export default Cryptocurrencies
